import {Pipe, PipeTransform} from '@angular/core';
import {Ticket} from '../../model/Ticket';

@Pipe({
  name: 'statedisplay',
  standalone: true,
})
export class StateDisplayPipe implements PipeTransform {

  transform(state: string): string {
    return state.replace(/\(action ls\)/ig, '').replace(/\(action client\)/ig, '').replace(/new/ig, 'Nouveau ticket');
  }
}
